<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title text-center mb-4">Iniciar Sesión</h2>
            
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>

            <form @submit.prevent="handleSubmit">
              <div class="mb-3">
                <label for="email" class="form-label">Email o Usuario</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  v-model="formData.email"
                  required
                  :class="{ 'is-invalid': emailError }"
                >
                <div class="invalid-feedback">
                  {{ emailError }}
                </div>
              </div>

              <div class="mb-3">
                <label for="password" class="form-label">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  v-model="formData.password"
                  required
                  :class="{ 'is-invalid': passwordError }"
                >
                <div class="invalid-feedback">
                  {{ passwordError }}
                </div>
              </div>

              <div class="d-grid mb-2">
                <button 
                  type="submit" 
                  class="btn btn-primary"
                  :disabled="loading"
                >
                  <span 
                    v-if="loading" 
                    class="spinner-border spinner-border-sm me-2"
                  ></span>
                  {{ loading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
                </button>
              </div>
              <div class="text-center">
                <router-link to="/recuperar-password" class="text-dark small">
                  ¿Olvidaste tu contraseña?
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import axios from '../config/axios';
import { esRedirectInterno } from '../utils/atajoPwa';

export default {
  name: 'LoginView',
  
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const loading = ref(false);
    const error = ref('');
    const emailError = ref('');
    const passwordError = ref('');

    const formData = ref({
      email: '',
      password: ''
    });

    const validateForm = () => {
      let isValid = true;
      emailError.value = '';
      passwordError.value = '';

      if (!formData.value.email.trim()) {
        emailError.value = 'El email o usuario es requerido';
        isValid = false;
      }

      if (!formData.value.password) {
        passwordError.value = 'La contraseña es requerida';
        isValid = false;
      }

      return isValid;
    };

    const handleSubmit = async () => {
      if (!validateForm()) return;

      loading.value = true;
      error.value = '';

      try {
        await store.dispatch('auth/login', formData.value);
        if (store.getters['auth/isAuthenticated']) {
          const redirect = route.query.redirect;
          if (esRedirectInterno(redirect)) {
            router.push(redirect);
          } else {
            const vista = store.getters['auth/vistaInicio'] || '/';
            router.push(vista);
          }
        } else {
          throw new Error('Error de autenticación: No se pudo establecer la sesión');
        }
      } catch (err) {
        console.error('Error detallado:', err);
        if (err.response) {
          console.error('Respuesta del servidor:', err.response.data);
          error.value = err.response.data.error || 'Error al iniciar sesión';
        } else if (err.request) {
          console.error('No se recibió respuesta del servidor');
          error.value = 'Error de conexión con el servidor';
        } else {
          console.error('Error de configuración:', err.message);
          error.value = 'Error al procesar la solicitud';
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      formData,
      loading,
      error,
      emailError,
      passwordError,
      handleSubmit
    };
  }
};
</script> 